// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section,
video {
  display: block;
}

body {
  line-height: 1;
}

ol {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-size: 14px;
  line-height: 171%;
  font-weight: 600;
  margin: 0;
  box-sizing: border-box;
  background: #fff;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  color: #000;
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/sass/common/_reset.scss","webpack://./src/sass/index.scss","webpack://./src/sass/mixins/_typography.scss"],"names":[],"mappings":"AAAA;;;CAAA;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+EI,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;ACEJ;;ADAA,gDAAA;AACA;;;;;;;;;;;;EAYI,cAAA;ACGJ;;ADDA;EACI,cAAA;ACIJ;;ADFA;EACI,gBAAA;ACKJ;;ADHA;;EAEI,YAAA;ACMJ;;ADJA;;;;EAII,WAAA;EACA,aAAA;ACOJ;;ADLA;EACI,WAAA;EACA,yBAAA;EACA,iBAAA;ACQJ;;ADLA;;;EAGI,mBAAA;ACQJ;;AAtIA;ECUI,eAAA;EACA,iBAAA;EACA,gBAAA;EDVA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA2IJ","sourcesContent":["/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n*/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection,\nvideo {\n    display: block;\n}\nbody {\n    line-height: 1;\n}\nol {\n    list-style: none;\n}\nblockquote,\nq {\n    quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n    content: '';\n    content: none;\n}\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: inherit;\n}","@import './common/reset';\n@import './common/variables';\n@import './common/fonts';\n@import './mixins';\n\nbody {\n    @include body1;\n    margin: 0;\n    box-sizing: border-box;\n    background: #fff;\n    font-family: 'Montserrat', sans-serif;\n    font-style: normal;\n    color: #000;\n    overflow-x: hidden;\n}\n","@import 'src/sass/common/variables';\n\n@mixin h4 {\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin title1 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 133%;\n}\n\n@mixin body1 {\n    font-size: 14px;\n    line-height: 171%;\n    font-weight: 600;\n}\n\n@mixin caption {\n    @include body1;\n    font-weight: 800;\n}\n\n@mixin textWithDots {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
